import axios from "axios"
import { awsBasePath } from "./_config"

const SearchService = {
  searchWebsite: (query, page, perPage, type, website = false) => {
    return axios.get(`${awsBasePath}/es/search`, {
      params: { query, page, perPage, type, website },
    })
  },
  searchBlogPosts: async (query, page = 1, perPage = 10) => {
    const response = await SearchService.searchWebsite(
      query,
      page,
      perPage,
      "blog_post",
      true,
    )
    return response && response.data
  },

  searchRoutes: async (query, page = 1, perPage = 10) => {
    const response = await SearchService.searchWebsite(
      query,
      page,
      perPage,
      "routes",
      true,
    )
    return response && response.data
  },

  searchTours: async (query, page = 1, perPage = 10) => {
    const response = await SearchService.searchWebsite(
      query,
      page,
      perPage,
      "tours",
      true,
    )
    return response && response.data
  },
}

export default SearchService
